
import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { ISolCustomerCurrency, ISolCustomerOrderAmounts } from "@/entities";
import { Getter } from "vuex-class";
@Component({
  name: "detail-amounts",
})
export default class DetailAmounts extends Vue {
  @Prop({ required: true })
  amounts!: ISolCustomerOrderAmounts[];
  @Getter("getSolCustomerCurrencies")
  solCustomerCurrencies!: ISolCustomerCurrency[];
  constructor() {
    super();
  }

  getCurrencySymbol(currencyIsoCode: string): string {
    const currency = this.solCustomerCurrencies.find(
      (currency) => currency.isoCode === currencyIsoCode
    );
    return currency?.symbol || "";
  }
}
